// Utils
import { getTitle } from '../../../../common/elements/utils/elementPropertyUtils';
import { HybridUseCase } from '../../../hybridApp/hybridAppConstants';
import { getHybridUseCase } from '../../../hybridApp/hybridAppUtils';
import { getShowTitle, getTitleSuggestionAck } from '../../taskList/taskListSelector';

const isListHybridUseCase = () => {
    switch (getHybridUseCase()) {
        case HybridUseCase.ANDROID_BOARD_LIST:
        case HybridUseCase.IOS_BOARD_LIST:
            return false;
        case HybridUseCase.IOS_CANVAS:
        case HybridUseCase.IPAD_OS:
        default:
            return true;
    }
};

export const shouldShowTitleSuggestion = (element) => {
    // In board list mode, do not show the suggestion.
    if (!isListHybridUseCase()) return false;

    // If is showing a title then don't suggest
    if (getShowTitle(element)) return false;

    // If already showing a title then don't suggest
    if (!!getTitle(element)) return false;

    // If already acknowledged then don't suggest
    if (getTitleSuggestionAck(element)) return false;

    return true;
};
